if ($('.col_jheight').length && $(window).width() >= 1200) {
	let totalHeight = 0;
	let rowHeight = 0;
	$('.col_jheight').children().each(function () {
		totalHeight += $(this).outerHeight(true);
	});

	rowHeight = $('.col_jheight').parent('.row').height();

	if (rowHeight > totalHeight) {
		$('.col_jheight').css('min-height', rowHeight);
	} else {
		$('.col_jheight').css('min-height', totalHeight + 70);
	}
}

$(window).resize(function () {
	if ($('.col_jheight').length) {
		if ($(window).width() >= 1200) {
			let totalHeight = 0;
			let rowHeight = 0;
			$('.col_jheight').children().each(function () {
				totalHeight += $(this).outerHeight(true);
			});

			rowHeight = $('.col_jheight').parent('.row').height();

			if (rowHeight > totalHeight) {
				$('.col_jheight').css('min-height', rowHeight);
			} else {
				$('.col_jheight').css('min-height', totalHeight + 70);
			}
		}
		else {
			$('.col_jheight').css('min-height', 'auto');
		}
	}
});



// WEBPACK FOOTER //
// ./_dev/blocks/col/col.js